import React from 'react';
import { withContent } from '../../hoc/withContext';
import {
  PriceBannerBlockContainer,
  PriceBannerDescription, PriceBannerImageContainer, PriceBannerInformationContainer,
  PriceBannerSubscriptionButton,
  UbisoftPlusLogoContainer, SubscriptionPriceContainer
} from './PriceBannerBlockStyle';
import { IContent } from '../../types';
import { ReactComponent as UbisoftPlusLogo } from '../../assets/ubisoftPlusLogo.svg';
import SubscriptionButton from '../UI/Buttons/SubscriptionButton/SubscriptionButton';
import PictureImage from '../../utils/Image/PictureImage';
import Fade from 'react-reveal/Fade';
import CONFIG from '../../config';
const IMAGE_NAME = 'valhala_fenyx_rysing_background'

interface IPriceBannerProps {
  context? : IContent;
}

const PriceBannerBlock = ({context} : IPriceBannerProps) => {
  return (
    <Fade center duration={350}>
      <PriceBannerBlockContainer>
        <PriceBannerImageContainer>
          <PictureImage
            images={[{
              imageName: IMAGE_NAME + '_desktop',
              minWidth: 850
            },{
              imageName: IMAGE_NAME + '_tablet',
              minWidth: 461
            }, {
              imageName: IMAGE_NAME + '_mobile',
              minWidth: 0
            }
            ]}
            extension="jpg"
            altText={IMAGE_NAME}
            className={['']}
          />
        </PriceBannerImageContainer>
        <PriceBannerInformationContainer>
          <UbisoftPlusLogoContainer>
            <UbisoftPlusLogo />
          </UbisoftPlusLogoContainer>
          <PriceBannerDescription>{context.priceBanner.subTitle}</PriceBannerDescription>
          <SubscriptionPriceContainer>
            <discover-components-subscription-price
              locale="en"
              theme={CONFIG.isUPC ? 'uplay' : 'store'}
              customTheme={CONFIG.isUPC ? 'uplay' : 'store'}
              textColor={'white'}
              size="defaultSizes"
            ></discover-components-subscription-price>
          </SubscriptionPriceContainer>
          <PriceBannerSubscriptionButton>
            <SubscriptionButton context={''} idToAttach={'priceBannerSubscriptionButton'} />
          </PriceBannerSubscriptionButton>
        </PriceBannerInformationContainer>
      </PriceBannerBlockContainer>
    </Fade>
  );
};

export default withContent(PriceBannerBlock);